/*
 * $Id:: filterItems.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const IP_RIGHT_TYPE = ['All IP types', 'Trademarks', 'Designs', 'PATENTS'];

const filters = {
    trademark: [
        {
            globalsKey: 'requestNames',
            filterid: 'requestNames',
            name: 'requestNames',
            placeholder: 'request.name',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'modalities',
            filterid: 'modality',
            name: 'modality',
            placeholder: 'modality',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'requestStatuses',
            filterid: 'requestStatus',
            name: 'requestStatus',
            placeholder: 'request.status',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'registrationStatuses',
            filterid: 'registrationStatus',
            name: 'registrationStatus',
            placeholder: 'registration.status',
            filterOptions: [],
            multiple: true,
        },
        // {
        //     filterid: 'NICE_CLASS',
        //     name: 'classes',
        //     placeholder: 'application.nice.classification',
        //     filterOptions: Array.from({ length: 45 }, (_x, i) => `${i + 1}`),
        //     multiple: true,
        // },
        // {
        //     globalsKey: 'statuses',
        //     filterid: 'TRADEMARK_STATUS',
        //     name: 'statuses',
        //     placeholder: 'application.status',
        //     filterOptions: [],
        //     multiple: true,
        // },
        {
            filterid: 'dateIntervalApplication',
            name: 'dates',
            placeholder: 'date',
        },
        {
            globalsKey: 'submitYears',
            filterid: 'submitYears',
            name: 'submitYears',
            placeholder: 'submit.year',
            filterOptions: [],
            multiple: true,
        },
    ],
    design: [
        // {
        //     globalsKey: 'locarnoClasses',
        //     filterid: 'LOCARNO_CLASS',
        //     name: 'locarno',
        //     placeholder: 'locarno.classification',
        //     filterOptions: [],
        //     multiple: false,
        // },
        // {
        //     globalsKey: 'statuses',
        //     filterid: 'DESIGN_STATUS',
        //     name: 'statuses',
        //     placeholder: 'application.status',
        //     filterOptions: [],
        //     multiple: true,
        // },
        // {
        //     filterid: 'DATES',
        //     name: 'dates',
        //     placeholder: 'dates',
        // },
        {
            globalsKey: 'requestNames',
            filterid: 'requestNames',
            name: 'requestNames',
            placeholder: 'request.name',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'modalities',
            filterid: 'modality',
            name: 'modality',
            placeholder: 'modality',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'requestStatuses',
            filterid: 'requestStatus',
            name: 'requestStatus',
            placeholder: 'request.status',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'registrationStatuses',
            filterid: 'registrationStatus',
            name: 'registrationStatus',
            placeholder: 'registration.status',
            filterOptions: [],
            multiple: true,
        },
        {
            filterid: 'dateIntervalApplication',
            name: 'dates',
            placeholder: 'date',
        },
        {
            globalsKey: 'submitYears',
            filterid: 'submitYears',
            name: 'submitYears',
            placeholder: 'submit.year',
            filterOptions: [],
            multiple: true,
        },
    ],
    patents: [
        // {
        //     globalsKey: 'ipRightType',
        //     filterid: 'IP_RIGHT_TYPE',
        //     name: 'ipRightType',
        //     placeholder: 'ip.right.type',
        //     filterOptions: IP_RIGHT_TYPE,
        //     multiple: false,
        // },
        // {
        //     globalsKey: 'FilteringType',
        //     filterid: 'FILTERING_TYPE',
        //     name: 'formTypes',
        //     placeholder: 'form.type',
        //     filterOptions: [],
        //     multiple: true,
        // },
        // {
        //     globalsKey: 'statuses',
        //     filterid: 'ESERVICES_STATUS',
        //     name: 'statuses',
        //     placeholder: 'application.status',
        //     filterOptions: [],
        //     multiple: true,
        // },
        // {
        //     filterid: 'DATES',
        //     name: 'dates',
        //     placeholder: 'dates',
        // },
        {
            globalsKey: 'requestNames',
            filterid: 'requestNames',
            name: 'requestNames',
            placeholder: 'request.name',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'modalities',
            filterid: 'modality',
            name: 'modality',
            placeholder: 'modality',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'requestStatuses',
            filterid: 'requestStatus',
            name: 'requestStatus',
            placeholder: 'request.status',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'registrationStatuses',
            filterid: 'registrationStatus',
            name: 'registrationStatus',
            placeholder: 'registration.status',
            filterOptions: [],
            multiple: true,
        },
        {
            filterid: 'dateIntervalApplication',
            name: 'dates',
            placeholder: 'date',
        },
        {
            globalsKey: 'submitYears',
            filterid: 'submitYears',
            name: 'submitYears',
            placeholder: 'submit.year',
            filterOptions: [],
            multiple: true,
        },
    ],
};

const trademarksActionOptions = [
    'TM Renewal',
    'TM Transfer',
    'TM Change Owner Details',
    'TM Change Rep/Corr details',
    'TM Generic',
    'TM License Contract',
    'TM Rights in rem',
];

const initiateActions = {
    trademarks: trademarksActionOptions,
    designs: [...trademarksActionOptions, 'TM Withdrawal/Surrender', 'TM Limit G&S'],
};

const getInitiateActions = (category) => initiateActions[category] || [];

const getDropDownFilters = (category) => filters[category] || [];

export default {
    getDropDownFilters,
    getInitiateActions,
};
